module.exports = "/_next/static/images/ba-0dd4db87c3e239c5c8226cb48f3a1c7d.svg";